export const isChromeless = (search: string) => {
  const params = new URLSearchParams(search);

  return params.get('chromeless') === 'true';
};
